// @file Vuex Store for Attachment handling
import { Module } from 'vuex'
import { RootState } from 'vuexstore/surface/types'

export interface AttachmentState {
  fileUploadingToPickerBox: File | null
  linkDisplayAttributes: { [url: string]: any }
  surfacePreviewImageLoaded: Record<string, boolean>
}

const defaultState = (): AttachmentState => ({
  fileUploadingToPickerBox: null,
  linkDisplayAttributes: {},
  surfacePreviewImageLoaded: {},
})

const attachmentModule: Module<AttachmentState, RootState> = {
  namespaced: true,
  state: defaultState,
  getters: {
    fileUploadingToPickerBox: (state): any => state.fileUploadingToPickerBox,
    linkDisplayAttributesForUrl:
      (state): any =>
      (url): any =>
        state.linkDisplayAttributes[url],
    surfacePreviewImageLoaded: (state) => state.surfacePreviewImageLoaded,
    isSurfacePreviewImageLoadedForUrl:
      (state): Function =>
      (url: string): boolean =>
        state.surfacePreviewImageLoaded[url] || false,
  },
  mutations: {
    UPLOAD_FILE(state, file): void {
      state.fileUploadingToPickerBox = file
    },
    COMPLETE_UPLOAD_FILE(state): void {
      state.fileUploadingToPickerBox = null
    },
    CANCEL_UPLOAD_FILE(state): void {
      state.fileUploadingToPickerBox = null
    },
    UPDATE_LINK_DISPLAY_ATTRIBUTES(state, { url, attributes }): void {
      state.linkDisplayAttributes = {
        ...state.linkDisplayAttributes,
        [url]: attributes,
      }
    },
    SET_SURFACE_PREVIEW_IMAGE_LOADED(state, { url }: { url: string }): void {
      state.surfacePreviewImageLoaded = { ...state.surfacePreviewImageLoaded, [url]: true }
    },
  },
  actions: {
    uploadFileToPickerBox({ commit }, { file }): void {
      commit('UPLOAD_FILE', file)
    },
    completeUploadingFileToPickerBox({ commit }): void {
      commit('COMPLETE_UPLOAD_FILE')
    },
    cancelUploadFileToPickerBox({ commit }): void {
      commit('CANCEL_UPLOAD_FILE')
    },
    updateLinkDisplayAttributes({ commit }, payload): void {
      commit('UPDATE_LINK_DISPLAY_ATTRIBUTES', payload)
    },
    setSurfacePreviewImageLoaded({ commit }, { url }: { url: string }): void {
      if (url) {
        commit('SET_SURFACE_PREVIEW_IMAGE_LOADED', { url })
      }
    },
  },
}

export default attachmentModule
